var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-snackbar',{attrs:{"v-model":_vm.snackbar,"vertical":_vm.vertical},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"color":"indigo","text":""}},'v-btn',attrs,false),[_vm._v(" Fechar ")])]}}])},[_vm._v(" "+_vm._s(_vm.texto)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }